import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import QRCodeGenerator from 'qrcode'
import { PostRequestV2 } from '../../common/api'
import { urls } from '../../common/constants'
import { getNum, getTrackingUrl } from '../../common/helper'
import { paytypes } from "../../common/paymentsMode"

export const tabLabels = ['Pending Delivery At My Branch', 'Pending Other Delivery At My Branch', 'Pending My Delivery At Other Branch']

export const headCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '4px 6px 4px 6px',
  color: '#fff',
  fontFamily: 'Roboto',
  fontWeight: 600,
}

export const cellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '6px',
  fontFamily: 'Roboto',
  // fontWeight: 500,
  color: '#444444'
}
export const excelHeadCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '4px 6px 4px 6px',
  color: '#444444',
  fontFamily: 'Roboto',
  fontWeight: 600,
}
export const excelCellStyles = {
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  borderColor: '#ccc',
  padding: '6px',
  fontFamily: 'Roboto',
  color: '#444444',
  fontSize: '16px'
}
export const transparentStyle = (theme) => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  marginRight: '0',
  color: theme.palette.primary.main,
  fontWeight: 'bold',
})

export const paymentTypeStyles = {
  padding: '4px 9px',
  fontSize: '12px',
  borderRadius: '30px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '6vw'
}
export const transformData = (inputArray, commonData, loginData) => {
  const outputArray = inputArray.map(item => ({
    intDeliveryID: 0,
    intCompanyID: loginData.intCompanyID,
    intBookingID: item.BookingID,
    strReceivedBy: commonData.ReceivedBy,
    strIDProof: commonData.IDProof,
    strOctroiRcptNo: item.OctroiReceiptNo,
    dtOctroiRcptDate: item.OctroiReceiptDate,
    dblOctroiRcptAmt: parseFloat(item.OctroiReceiptAmt),
    strRemarks: commonData.Remarks,
    intUsreID: commonData.intUserID,
    intPaymentType: commonData.PaymentType,
    strPaymentDetails: '',
    dblFreight: parseFloat(item.Freight),
    dblCollectionChg: parseFloat(item.CollectionCharges),
    dblCartage: parseFloat(item.CartageAmount),
    dblDocumentChg: parseFloat(item.DocumentCharges),
    dblInsurance: parseFloat(item.Insurance),
    dblServiceTax: parseFloat(item.ServiceTaxAmount),
    dblTotal: parseFloat(item.NetAmount),
    dblTotalDues: parseFloat(item.TotalDues),
    dblHomeDeliveryChg: parseFloat(item.HomeDeliveryChg),  //input 2 
    dblOutstanding: parseFloat(item.Outstanding),
    dblGoodsValue: parseFloat(item.GoodsValue),
    intReceivingPartyID: commonData.ReceivingPartyID,
    dblAddtitionalDeliveryCartage: parseFloat(item.AdditionalDeliveryCartage), //input 1 
    dblOctroiBrokerageAmt: parseFloat(item.OctroiBrokerageAmt),
    dblDemurrageChg: parseFloat(item.DemurrageChg), //input 4
    intIDProofid: commonData.SenderIDProofID,
    strreceiverimgurl: item.ReceiverImageURL,
    strIDProofimgurl: item.SenderIDProffUrl,
    dblLatitude: 0,
    dblLongitude: 0,
    strDeliverdLocation: "",
    IsDeliverdLocation: 0,
    dblDeliveryGST: parseFloat(item.DeliveryGST), //input 6
    strReceiverContactNo: commonData.RecMobileNo,
    dblExtraHamali: parseFloat(item.ExtraHamli), //input 3
    strVehicleNo: commonData.VehicleNo,
    strReceiverGSTN: item.ReceiverGSTN,
    strGSTPaidBy: item.ServiceTaxPaidBy,
    dblDeliveryDisc: item?.Discount || 0,  //input 5 
    WalletOrderId: 0,
    GSTNState: '',
    DelGSTAmount: parseFloat(item.DeliveryGST),
    IsDeliveryRCM: 0,
    AccountNo: "",
    TransactionID: ""
  }));

  return outputArray;
}

const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

const sanitizePdfFileName = (value) => String(value || 'DeliveryTicket').replace(/[\\/:*?"<>|]/g, '-')

const waitForImages = (element) => {
  const images = Array.from(element.querySelectorAll('img'))
  return Promise.all(
    images.map((img) => {
      if (img.complete) return Promise.resolve()
      return new Promise((resolve) => {
        img.onload = resolve
        img.onerror = resolve
      })
    })
  )
}

export const getSuccessfulDeliveryPrintList = (bulkResponse, deliveredLrs = []) => {
  const [responses = []] = Array.isArray(bulkResponse) ? bulkResponse : []
  return responses.reduce((printList, response, index) => {
    if (response?.status !== 'Success') return printList

    const selectedLr = deliveredLrs[index] || {}
    const responseData = response?.Data?.Table?.[0] || {}
    const BookingID = response?.BookingID || responseData?.BookingID || selectedLr?.BookingID
    const LRNO = response?.LRNO || responseData?.LRNO || selectedLr?.LRNO

    if (!BookingID && !LRNO) return printList
    return [...printList, { ...selectedLr, ...responseData, BookingID, LRNO }]
  }, [])
}

export const downloadHtmlAsPdf = async (html, fileName, ticketDimension = null) => {
  const wrapper = document.createElement('div')
  wrapper.style.position = 'fixed'
  wrapper.style.left = '-10000px'
  wrapper.style.top = '0'
  wrapper.style.background = '#fff'
  wrapper.innerHTML = html
  document.body.appendChild(wrapper)

  try {
    await waitForImages(wrapper)
    const canvas = await html2canvas(wrapper.firstElementChild || wrapper, {
      backgroundColor: '#fff',
      scale: 2,
      useCORS: true,
    })
    const imageData = canvas.toDataURL('image/png')

    if (ticketDimension) {
      const [height, width] = ticketDimension
      const pdfWidth = +width + 5
      const pdfHeight = +height
      const doc = new jsPDF({
        orientation: pdfWidth > pdfHeight ? 'l' : 'p',
        unit: 'mm',
        format: [pdfWidth, pdfHeight],
      })
      doc.addImage(imageData, 'PNG', 0, 0, pdfWidth, pdfHeight)
      doc.save(`${sanitizePdfFileName(fileName)}.pdf`)
      return
    }

    const doc = new jsPDF('p', 'mm', 'a4')
    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()
    const imageHeight = (canvas.height * pageWidth) / canvas.width
    let remainingHeight = imageHeight
    let y = 0

    doc.addImage(imageData, 'PNG', 0, y, pageWidth, imageHeight)
    remainingHeight -= pageHeight

    while (remainingHeight > 0) {
      y -= pageHeight
      doc.addPage()
      doc.addImage(imageData, 'PNG', 0, y, pageWidth, imageHeight)
      remainingHeight -= pageHeight
    }

    doc.save(`${sanitizePdfFileName(fileName)}.pdf`)
  } finally {
    document.body.removeChild(wrapper)
  }
}

const getTicketLineHtml = (item, ticketData) => {
  if (item.includes('--THERMAL-PRINT-SPLITTER--')) return ''

  const [, value, left, top, fontSize, v, fontWeight] = item.split('|')
  const displayValue = v === 'V' ? ticketData?.[value?.replaceAll('@', '')] : value
  const whiteSpace = v === 'V' ? 'pre-line' : 'normal'

  return `
    <span style="
      position:absolute;
      font-size:${getNum(fontSize)}pt;
      left:calc(${getNum(left) + 10}px + 2.5mm);
      top:${top}px;
      font-weight:${fontWeight == 1 ? 'bold' : 'normal'};
      color:#000;
      font-family:Arial,Helvetica,'Segoe UI',Roboto,sans-serif;
      white-space:${whiteSpace};
    ">${escapeHtml(displayValue)}</span>
  `
}

const getQrAndLogoHtml = async (formatList, ticketData, loginData) => {
  const ticketParams = {
    BookingID: ticketData?.BookingID,
    intUserID: loginData?.intUserID,
  }
  const lrDetailUrl = getTrackingUrl.call(ticketParams)
  const qrDataUrl = await QRCodeGenerator.toDataURL(lrDetailUrl, { margin: 0, width: 256 })

  return formatList
    .map((item) => {
      const [printType, left, top, height, width] = item.split('|')
      if (printType === 'QR') {
        return `<img src="${qrDataUrl}" style="position:absolute;left:${left}px;top:${top}px;height:${height}px;width:${width}px;" />`
      }
      if (printType === 'Logo') {
        return `<img crossorigin="anonymous" src="${ticketData?.LogoURL || ''}" style="position:absolute;left:${left}px;top:${top}px;height:${height}px;width:${width}px;" />`
      }
      return ''
    })
    .join('')
}

export const getTicketHtml = async (ticketData, ticketFormatDetail, loginData) => {
  const ticketDimension = ticketFormatDetail?.TicketDimension?.split(',') || []
  const ticketFormat = ticketFormatDetail?.TicketFormat?.split('^') || []
  const qrAndLogoFormat = ticketFormatDetail?.QRandLogoFormat?.split('^') || []
  const qrAndLogoHtml = await getQrAndLogoHtml(qrAndLogoFormat, ticketData, loginData)
  const formatFont = ticketFormatDetail?.FormatFont
    ? `${ticketFormatDetail.FormatFont},Arial,Helvetica,'Segoe UI',Roboto,sans-serif`
    : 'Microsoft Sans Serif,Arial,Helvetica,Segoe UI,Roboto,sans-serif'

  return {
    ticketDimension,
    html: `
      <div style="
        position:relative;
        background:#fff;
        width:${+ticketDimension[1] + 5}mm;
        height:${ticketDimension[0]}mm;
        font-family:${formatFont};
        color:#000;
        overflow:hidden;
      ">
        ${ticketFormat.map((item) => getTicketLineHtml(item, ticketData)).join('')}
        ${qrAndLogoHtml}
      </div>
    `,
  }
}

export const downloadDeliveryTicketPdf = async (item, context) => {
  const { intBranchID, loginData } = context
  const printPayload = {
    intBookingID: item?.BookingID,
    intBranchID,
    intUserID: loginData?.intUserID,
    strLRNO: item?.LRNO,
  }
  const printResponse = await PostRequestV2(urls.printDelivery, printPayload)
  const ticketData = printResponse?.status === 'Success' ? printResponse?.Data?.Table?.[0] : null

  if (!ticketData) return false

  const lrNo = ticketData?.LRNO || item?.LRNO

  if (ticketData?.CargoHasBilltyLaserPrint == 1 && ticketData?.BilltyTemplate) {
    await downloadHtmlAsPdf(ticketData.BilltyTemplate, lrNo)
    return true
  }

  const formatResponse = await PostRequestV2(urls.cargoTicketFormat, {
    intTicketFormatID: ticketData?.TicketFormatID || 0,
    intCompanyID: 0,
    strFormatType: ticketData?.FormatTypeCust || 'B',
    intIsDeleted: 0,
  })
  const ticketFormatDetail = formatResponse?.status === 'Success' ? formatResponse?.Data : null

  if (!ticketFormatDetail) return false

  const { html, ticketDimension } = await getTicketHtml(ticketData, ticketFormatDetail, loginData)
  if (!ticketDimension?.[0] || !ticketDimension?.[1]) return false

  await downloadHtmlAsPdf(html, lrNo, ticketDimension)
  return true
}

export const DownloadDeliveredTicketPdfs = async (bulkResponse, deliveredLrs, context) => {
  const printList = getSuccessfulDeliveryPrintList(bulkResponse, deliveredLrs)
  let downloadCount = 0

  for (const item of printList) {
    try {
      const isDownloaded = await downloadDeliveryTicketPdf(item, context)
      if (isDownloaded) downloadCount += 1
    } catch (err) {
      console.log(err)
    }
  }

  return downloadCount
}
export const excelButton = {
  color: '#0086ff'
}

export const tablefilterLabel1 = [
  [{ name: 'LR No.', id: 'LRNO', marginB: true }, { name: 'Offline LR No', id: 'ManualLRNo' }],
  [{ name: 'Payment', id: 'PaymentType', marginB: true }, { name: 'LR Due Amt.', id: 'TotalDues' }],
  [{ name: 'City', id: 'SourceCity', marginB: true }, { name: 'Branch', id: 'SourceBranch' }],
  [{ name: 'City', id: 'DestinationCity', marginB: true }, { name: 'Branch', id: 'DestinationBranch' }],
  [{ name: 'Receiver Name', id: 'RecName', marginB: true }, { name: 'Receiver No.', id: 'RecMobileNo' }],
  [{ name: 'Date', id: 'ReceiptDate', marginB: true }, { name: 'Challan No', id: 'ChallanNo' }],
  { name: 'No of Units', id: 'Units', disabled: true },
  { name: 'Cartage', id: 'CartageAmount', disabled: true },
  { name: 'Hamali', id: 'DeliveryChg', disabled: true },
  { name: 'Op. Hamali', id: 'OperatorHamaliChg', disabled: true },
  { name: 'Charges', id: 'DemurrageChg', disabled: true },
  { name: 'Discount', id: 'discount', disabled: true },
  { name: 'GST', id: 'GST', disabled: true },
  { name: 'Total', id: 'total', disabled: true },
];
export const tablefilterLabel2 = [
  { name: 'LR No.', id: 'LRNO', marginB: true },
  { name: 'Offline LR No', id: 'ManualLRNo' },
  { name: 'Payment', id: 'PaymentType', marginB: true },
  { name: 'LR Due Amt.', id: 'TotalDues' },
  { name: 'City', id: 'SourceCity', marginB: true },
  { name: 'Branch', id: 'SourceBranch' },
  { name: 'City', id: 'DestinationCity', marginB: true },
  { name: 'Branch', id: 'DestinationBranch' },
  { name: 'Receiver Name', id: 'RecName', marginB: true },
  { name: 'Receiver No.', id: 'RecMobileNo' },
  { name: 'Date', id: 'ReceiptDate', marginB: true },
  { name: 'Challan No', id: 'ChallanNo' },
  { name: 'No of Units', id: 'Units', disabled: true },
  { name: 'Cartage', id: 'CartageAmount', disabled: true },
  { name: 'Hamali', id: 'HamaliCharges', disabled: true },
  { name: 'Op. Hamali', id: 'OperatorHamaliChg', disabled: true },
  { name: 'Charges', id: 'DemurrageChg', disabled: true },
  { name: 'Discount', id: 'Discount', disabled: true },
  { name: 'GST', id: 'GST', disabled: true },
  { name: 'Total', id: 'BillAmount', disabled: true },
];

export const getTransferData = (inputArray, commonData) => {
  const outputArray = inputArray.map((data) => ({
    intBranchTransferID: 0,
    intFromCityID: data.CurrentCityID,
    intToCityID: commonData.toCity,
    intFromBranchID: data.CurrentBranchID,
    intToBranchID: commonData.BranchForDelTrans,
    intCompanyID: commonData.intCompanyID,
    strVehicleType: 'SV',
    strVehicleNo: commonData.VehicleNo,
    strTransferReason: commonData.Remarks,
    strRemarks: commonData.Remarks,
    intUserID: commonData.intUserID,
    blnDeliveryTransfer: true,
    intVehicleID: commonData.intVehicleID,
    strBookingIDs: data.BookingID,
    strLRNos: data.LRNO,
    strShortQtys: 0,
    strDamageQtys: 0,
    intDriverID: commonData.driverName,
  }))
  return outputArray
}
export const pancardValidation = (text) => {
  let regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  if (regex.test(text)) {
    return true;
  }
  return false;
}

export function ValidateAadhaar(aadhaar) {
  var expr = /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/;
  if (!expr.test(aadhaar)) {
    return false;
  } else {
    return true
  }
}

// export const calculateFinalAmounts = dataArray => {
//   const updatedArray = dataArray.map(data => {
//     let finalAmount=0
//     if(data?.PaymentType==='ToPayDDDV'||data?.PaymentType==='TOPAY'||data?.PaymentType==='TOPAY(MANUAL)'|| data?.PaymentType==='COD'){
//       finalAmount = +Number(data?.TotalDues)+ +data.AdditionalDeliveryCartage + +data.Deliverychg + +data.ExtraHamli + +data.DemurrageChg + +data.DeliveryGST  - data.Discount
//     }else{
//       finalAmount = +Number(data.AdditionalDeliveryCartage) + +data.Deliverychg + +data.ExtraHamli + +data.DemurrageChg + +data.DeliveryGST  - data.Discount
//     }
//     return {
//       ...data,
//       finalAmount:finalAmount,
//     }
//   });
//   return updatedArray;
// };

export const calculateFinalAmounts = (dataArray) => {
  const updatedArray = dataArray.map(data => ({
    ...data,
    finalAmount: calculateAmount(data)
  }));
  return updatedArray;
};

const calculateAmount = (data) => {
  const {
    PaymentTypeID,
    TotalDues = 0,
    AdditionalDeliveryCartage = 0,
    HomeDeliveryChg = 0,
    ExtraHamli = 0,
    DemurrageChg = 0,
    DeliveryGST = 0,
    Discount = 0
  } = data;

  const totalDuesVal = +TotalDues;
  const additionalDeliveryCartageVal = +AdditionalDeliveryCartage
  const deliveryChgVal = +HomeDeliveryChg
  const extraHamliVal = +ExtraHamli
  const demurrageChgVal = +DemurrageChg
  const deliveryGSTVal = +DeliveryGST
  const discountVal = +Discount

  let finalAmount = additionalDeliveryCartageVal + deliveryChgVal + extraHamliVal + demurrageChgVal + deliveryGSTVal - discountVal
  if ([paytypes.TO_PAY, paytypes.COD, paytypes.TO_PAY_MANUAL, paytypes.TO_PAY_DDDV].includes(PaymentTypeID)) {
    finalAmount = totalDuesVal + finalAmount
  }

  return finalAmount;
};